module.exports = __webpack_public_path__ + "static/media/glowco_3_loose pants in black.2e3c3def.jpeg";